import { MetalsProject } from "../models/metals-project.model";
import { MetalsTask } from "../models/metals-task.model";
import { toEntityDict } from "./to-entity-dict.function";

interface IdCreator {
	createId(): string;
}

export function copyMetalsTasksToNewProject(idCreator: IdCreator, newProject: MetalsProject, oldTasks: MetalsTask[]) {
	const oldTaskIdsToNewTask = toEntityDict(oldTasks.map(task => {
		const newTask: MetalsTask = {
			...task,
			completedQuantity: 0,
			projectId: newProject.id,
			id: idCreator.createId(),
			nextTaskId: null,
		}

		return { id: task.id, newTask }
	}))

	return oldTasks.map(t => {
		const updatedTask = oldTaskIdsToNewTask[t.id].newTask;
		if (t.nextTaskId) {
			updatedTask.nextTaskId = oldTaskIdsToNewTask[t.nextTaskId].newTask.id
		}

		return updatedTask
	});
}
